// ======================================================================
// 📁 drawer-planning.validation.js
// PURPOSE:
//   Merge validated schedule into planning operations
// ======================================================================

/**
 * Apply validated schedule into operations safely.
 */
export const applyValidatedSchedule = (
  operations = [],
  validatedOperations = []
) => {
  return operations.map((op) => {
    const match = validatedOperations.find(
      (v) => v.operation_seq_no === op.seq
    );

    if (!match) return op;

    // ✅ support both backend formats
    const start =
      match.planned_start_datetime ||
      match.suggested_start_datetime;

    const end =
      match.planned_end_datetime ||
      match.suggested_end_datetime;

    // 🔒 safety guard
    if (!start || !end) {
      console.warn(
        "Invalid validated schedule payload:",
        match
      );
      return op;
    }

    return {
      ...op,
      from: new Date(start).toISOString(),
      to: new Date(end).toISOString(),
    };
  });
};
